import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { ServicoMsg } from '../../servicos/srv.msg';
import { ServicoCampanha } from '../../servicos/srv.campanha';

@Component({
  selector: 'tsv2-cmp-listar',
  templateUrl: './listar.component.html',
  providers: [ ServicoMsg, ServicoCampanha ]
})
export class CampanhaListarComponent implements OnInit {
  @Input() items: any[];
  @Input() pagina: number;

  @Output() trocar = new EventEmitter();

  constructor(
    private servicoMsg: ServicoMsg,
    private servicoCampanha: ServicoCampanha
  ) {
    this.items = [];
    this.pagina = 1;
  }

  ngOnInit() {
  }

  removerCampanha(id){
    let titulo = 'Remover a campanha?';
    let texto = 'Campanha removida com sucesso!';
    this.servicoMsg.exibeAlerta(titulo, id, this.servicoCampanha, texto).then(r1 => {
      if (r1.success){
        this.trocar.emit(this.pagina);
      }
    }, (err: any) => {
      this.servicoMsg.exibeErro(err).then(r1 => {});
    });
  }

}
